import { StyleSheet, css } from "aphrodite"
import { useContext } from "react";
import { NavContext } from "./navbar.component";
import { FaRupeeSign } from "react-icons/fa";
import { formatToINR } from "../library/dataTransformer";
import { primaryColor, softBlack } from "../theme";
import { Dropdown, MenuProps } from "antd";
import { useGoldRateHook } from "../hooks/useGoldRateHook";
import { useSelector } from "react-redux";
import { GoldRateDTO } from "../models/goldRate";
import { GoldRateStateData } from "../store/goldRateSlice";
import { useDiamondRateHook } from "../hooks/useDiamondRateHook";
import { useIsMobileView } from "../hooks/useIsMobileView";
import { selectGoldRate } from "../store/sessionSelectors";

const oldGoldDiffPercentage = 0.056; // 4.6% difference for old gold rates
const mobileDropdownWidth = 'calc(100vw - 20px)';

const RateItems: (rate: GoldRateDTO) => MenuProps['items'] = (rate) => ([
    {
        key: '1',
        type: 'group',
        label: 'Gold Rates',
        children: [
            {
                key: '1-1',
                label: (<div>
                    18Karat: {formatToINR(rate?.rateOf18K || 0)}
                </div>
                ),
            },
            {
                key: '1-2',
                label: (<div>
                    22Karat: {formatToINR(rate?.rateOf22K || 0)}
                </div>
                ),
            },
            {
                key: '1-3',
                label: (<div>
                    24Karat: {formatToINR(rate?.rateOf24K || 0)}
                </div>
                ),
            },
        ]
    },
    {
        type: 'divider',
    },
    // {
    //     key: '2',
    //     type: 'group',
    //     label: 'Old Gold Sell/Cash Rates',
    //     children: [
    //         {
    //             key: '2-1',
    //             label: (<div>
    //                 18Karat: {formatToINR(rate?.rateOf18K - (oldGoldDiffPercentage * rate?.rateOf18K) || 0)}
    //             </div>),
    //         },
    //         {
    //             key: '2-2',
    //             label: (<div>
    //                 22Karat: {formatToINR(rate?.rateOf22K - (oldGoldDiffPercentage * rate?.rateOf22K) || 0)}
    //             </div>),
    //         },
    //         {
    //             key: '2-3',
    //             label: (<div>
    //                 24Karat: {formatToINR(rate?.rateOf24K - (oldGoldDiffPercentage * rate?.rateOf24K) || 0)}
    //             </div>),
    //         },
    //     ]
    // },
    // {
    //     type: 'divider',
    // },
    {
        key: '3',
        label: (
            <div>
                Last Updated: {new Date(rate.timestamp).toLocaleString()}
            </div>
        )
    },
]);


const GoldRateDisplay = () => {
    const goldRateState: GoldRateStateData = useSelector(selectGoldRate);
    useGoldRateHook();
    useDiamondRateHook();
    const isMobileView = useIsMobileView();
    const items = RateItems(GoldRateDTO.fromJSON(goldRateState));
    const { handleNavAction } = useContext(NavContext);
    const dropdownPlacement = isMobileView ? 'bottom' : 'bottomRight';
    const dropdownTrigger: ('click' | 'hover')[] = isMobileView ? ['click'] : ['hover'];
    const menuStyle = isMobileView
        ? { width: mobileDropdownWidth, maxWidth: mobileDropdownWidth }
        : { maxWidth: mobileDropdownWidth };


    return <Dropdown
        placement={dropdownPlacement}
        trigger={dropdownTrigger}
        autoAdjustOverflow
        getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
        overlayStyle={isMobileView ? { width: mobileDropdownWidth, maxWidth: mobileDropdownWidth } : undefined}
        menu={{ items, style: menuStyle }}
    >
        <div onClick={() => handleNavAction()} className={css(styles.roundShadow)}>
            <FaRupeeSign></FaRupeeSign> Gold Rate
        </div>
    </Dropdown>
}

const styles = StyleSheet.create({
    roundShadow: {
        cursor: "pointer",
        border: `2px solid ${softBlack}`,
        padding: "5px",
        borderRadius: "10px 10px",
        margin: "12px",
        ":hover": {
            borderColor: primaryColor
        },
        whiteSpace: 'nowrap'
    }

})

export default GoldRateDisplay